import { useState} from 'react';
import styles from '../styles/body.module.scss'
import {Box, TextField} from '@mui/material';
import FormControl from '@mui/material/FormControl';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import { useNavigate } from 'react-router-dom';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import Button from '@mui/material/Button';
import btnStyles from '../styles/buttons.module.scss'
import FormHelperText from '@mui/material/FormHelperText';
import{BottomNavigation, BottomNavigationAction} from '@mui/material'

export default function AccidentSummary({accidentSummary, setAccidentSummary, accidentActionTaken, setAccidentActionTaken, hoursLost, setHoursLost}){
    const navigate = useNavigate();
    const goBack = () => navigate(-1);

    const [accidentSummaryError, setAccidentSummaryError] = useState(false);
    const [accidentSummaryText, setAccidentSummaryText] = useState('');

    const [accidentActionTakenError, setAccidentActionTakenError] = useState(false);
    const [accidentActionTakenText, setAccidentActionTakenText] = useState('');

    const [hoursLostError, setHoursLostError] = useState(false);
    const [hoursLostText, setHoursLostText] = useState('');

    
    const handleAccidentSummaryChange = (newValue) => {
        setAccidentSummary(newValue);
    };

    const handleAccidentActionTakenChange = (newValue) => {
        setAccidentActionTaken(newValue);
    }

    const handleHoursLostChange = (newValue) => {
        setHoursLost(newValue);
    }
    

    const nextPage = () => {
        if(accidentSummary !== "" && accidentActionTaken !== "" && hoursLost !== ""){
            setAccidentSummaryText('');
            setAccidentSummaryError(false);
            setAccidentActionTakenText('');
            setAccidentActionTakenError(false);
            setHoursLostText('');
            setHoursLostError(false);
            if(accidentSummary.length >250){
                setAccidentSummaryText('Accident Summary must be less than 250 characters');
                setAccidentSummaryError(true);
            }
            else  if(accidentActionTaken.length >250){
                setAccidentActionTakenText('Actions taken/recommended must be less than 250 characters');
                setAccidentActionTakenError(true);
            }
            else{
                    navigate("/riddor");
                
            }

        }
        else{
            setAccidentSummaryText('');
            setAccidentSummaryError(false);
            setAccidentActionTakenText('');
            setAccidentActionTakenError(false);
            setHoursLostText('');
            setHoursLostError(false);
            if(accidentSummary === ""){
                setAccidentSummaryText('Please provide a summary of the accident or injury');
                setAccidentSummaryError(true);
            }
            if(accidentActionTaken === ""){
                setAccidentActionTakenText('Please provide a summary of the action taken/recommended');
                setAccidentActionTakenError(true);
            }
            if(hoursLost === ""){
                setHoursLostText('Please provide the number of hours lost due to this accident.');
                setHoursLostError(true);
            }
            
        }

    }
  return (
      <>
          <Box className={styles.questionH1Top} >
              <h1>Summary of the accident or injury</h1>
              </Box>
              <Box className={styles.textField}>
              <FormControl fullWidth margin="normal" className={styles.field} error={accidentSummaryError}>
                 <TextField error={accidentSummaryError} value={accidentSummary} inputProps={{maxLength: 250}} helperText={`${accidentSummary.length}/${250}`} fullWidth id="outlined-basic" multiline rows={5} label="Accident Summary" variant="outlined" onChange={e => handleAccidentSummaryChange(e.target.value)}  />
                 <FormHelperText>{accidentSummaryText}</FormHelperText>
              </FormControl>
              </Box>

              <Box className={styles.questionH1} >
              <h1>Action Taken/Recommended</h1>
              </Box>
              <Box className={styles.textField}>
              <FormControl fullWidth margin="normal" className={styles.field} error={accidentActionTakenError}>
                 <TextField error={accidentActionTakenError} value={accidentActionTaken} inputProps={{maxLength: 250}} helperText={`${accidentActionTaken.length}/${250}`} fullWidth id="outlined-basic" multiline rows={5} label="Action Taken/Recommended" variant="outlined" onChange={e => handleAccidentActionTakenChange(e.target.value)}  />
                 <FormHelperText>{accidentActionTakenText}</FormHelperText>
              </FormControl>
              </Box>

              <Box className={styles.questionH1} >
                <h1>How many hours have been lost due to this accident?</h1>
                </Box>
                <Box className={styles.textField} >
                    <FormControl fullWidth margin="normal" className={styles.field} error={hoursLostError}>
                        <TextField error={hoursLostError} value={hoursLost} type="tel" pattern="[0-9]*"
                            inputProps={{ maxLength: 3, inputMode: 'numeric' }}
                            fullWidth id="outlined-basic" label="Hours Lost" variant="outlined" onChange={(e) => {
                                const onlyDigits = e.target.value.replace(/\D/g, '');
                                handleHoursLostChange(onlyDigits.slice(0, 3));
                            }}/>
                        <FormHelperText>{hoursLostText}</FormHelperText>
                    </FormControl>
                </Box>
                <Box className={styles.statementH2} >
                <h2>This figure can be updated (edited) at a later date, after the report has been submitted.</h2>
                </Box>
              <Box className={btnStyles.navbuttons} >
              <Button startIcon={<ArrowBackIosNewIcon />} className={btnStyles.backBtn} size="large" variant="contained" onClick={() => goBack()}>Back</Button>
              <Button endIcon={<ArrowForwardIosIcon />} className={btnStyles.nextBtn} size="large" variant="contained"
                  onClick={() => nextPage()}
              >Next</Button>

          </Box>
          <Box className={btnStyles.bottomNavContainer}>
              <BottomNavigation sx={{
                  width: '100%',
                  position: 'fixed',
                  bottom: 0,
                  height:'70px',
                  zIndex: '1000'
              }} showLabels>
                  <BottomNavigationAction id="navBackButton" label='Back' icon={<ArrowBackIosNewIcon />} onClick={() => goBack()} />
                  <BottomNavigationAction id="navNextButton" label='Next' icon={<ArrowForwardIosIcon />} onClick={() => nextPage()} />
              </BottomNavigation>
          </Box>

      </>
      
  )
}
